import React from 'react';
import { Box, MenuItem, Select } from '@mui/material';
import { leadsSelectMenuProps } from '../../Leads/components/leadsUi.styles';
import { META_PERIOD_PRESETS } from '../metaPeriod';
import { metaPeriodSelectSx } from './metaAdsUi.styles';

/*
 * Ancho fijo = el de la etiqueta más larga («Máximo (90 días)»), medido por CSS: todas las
 * etiquetas van superpuestas en la misma celda de un grid; solo la elegida se ve (las demás
 * `visibility: hidden`, fuera del árbol accesible). Así el botón no cambia de tamaño al elegir,
 * sin px mágicos, y sigue igual si cambia la fuente. El menú de MUI ya toma como mínimo el ancho
 * del botón (`autoWidth` en false).
 */
const sizerSx = { display: 'inline-grid', verticalAlign: 'top' };
const labelSx = { gridArea: '1 / 1', whiteSpace: 'nowrap', textAlign: 'left' };

function PeriodValue({ value }) {
  return (
    <Box component="span" sx={sizerSx} data-testid="meta-period-select-sizer">
      {META_PERIOD_PRESETS.map((p) => (
        <Box
          key={p.key}
          component="span"
          sx={{ ...labelSx, visibility: p.key === value ? 'visible' : 'hidden' }}
          aria-hidden={p.key === value ? undefined : true}
          data-selected={p.key === value ? 'true' : undefined}
          data-testid={`meta-period-label-${p.key}`}
        >
          {p.label}
        </Box>
      ))}
    </Box>
  );
}

/** Selector de período (Campañas, Análisis / Informe y el informe de la ficha: el mismo componente). */
export default function MetaPeriodSelect({ value, onChange, testId = 'meta-period-select' }) {
  return (
    <Select
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      inputProps={{ 'aria-label': 'Período' }}
      MenuProps={leadsSelectMenuProps}
      renderValue={(v) => <PeriodValue value={v} />}
      sx={{ ...metaPeriodSelectSx, flexShrink: 0 }}
      data-testid={testId}
    >
      {META_PERIOD_PRESETS.map((p) => <MenuItem key={p.key} value={p.key}>{p.label}</MenuItem>)}
    </Select>
  );
}
